import { Pipe, PipeTransform } from '@angular/core';
import { cascadeModifiers, CascadedModifier } from './modifier-cascade';

/**
 * Orders an item's modifiers so sub-modifiers follow the option they hang
 * under, and stamps each row with a `depth` to indent by.
 *
 * A pipe rather than a component method: `*ngFor` re-evaluates a method call on
 * every change-detection pass, which would rebuild the tree for every row of
 * every item on screen. A pure pipe recomputes only when the modifiers array
 * reference actually changes.
 *
 * Usage:
 *   <div *ngFor="let mod of item.modifiers | modifierCascade"
 *        [style.marginLeft.px]="(mod.depth || 0) * 12">
 *
 * Rendering stays flat and unchanged — only the order and the indent differ.
 * See `modifier-cascade.ts` for the ordering rules.
 */
@Pipe({
  name: 'modifierCascade',
  standalone: true,
})
export class ModifierCascadePipe implements PipeTransform {
  transform(mods: any[] | null | undefined): CascadedModifier[] {
    return cascadeModifiers(mods);
  }
}
